import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom';
import ROUTE from '../../../common/Routes';
import { RegisterStyle } from './Register.styled'
import {RegisterValidationSchema} from "../../../validations/RegisterValidation"
import { useSelector } from 'react-redux';
import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';
import { useDB } from '../../../context/DynamoDBContext';
import { TextErrorStyle } from '../../../styles/ErrorStyles';


const Register = () => {
  const [email, setEmail] = useState('');
  const [emailErr, setEmailErr] = useState("")
  const [firstName, setFirstName] = useState("")
  const [firstErr, setFirstErr] = useState("")
  const [lastName, setLastName] = useState("")
  const [lastErr, setLastErr] = useState("")
  const [password, setPassword] = useState('');
  const [passwordErr, setPasswordErr] = useState("")
  const [err, setErr] = useState("")
  const navigate=useNavigate()
   const {dynamoDBClient}=useDB()
  const userRole=useSelector(state=>state.userRoleRed)

  const Errors=(err)=>{
    err.forEach((element) => {
      switch(element.split(':')[0]){
        case "1":
          setFirstErr(element.split(':')[1])
          break;
        case "2":
          setLastErr(element.split(':')[1])
          break;
        case "3":
          setEmailErr(element.split(':')[1])
          break;
        case "4":
          setPasswordErr(element.split(':')[1])
          break;
        default:
          setErr("An Error has occured")
          break;

      }
    })
  } 
  const handleSubmit =async (event) => {
    event.preventDefault();
    let hashedpassword=CryptoJS.SHA256(process.env.REACT_APP_SALT+password)
    hashedpassword=hashedpassword.toString(CryptoJS.enc.Base64)
    const uniqueId = uuidv4().toUpperCase() 
    const formData={
      firstName,
      lastName,
      email,
      password
    }
   await RegisterValidationSchema.validate(formData,{
    abortEarly:false
   }).then((value)=>{
      
      const now=new Date();
      const timestamp=now.toISOString().replace("T"," ").replace(/\.\d{3}Z$/, ' +0000')
      const offset=now.getTimezoneOffset() / 60;
      let params={};
          
      if(userRole.role === "1"){
        params={
          TableName:"Users",
          Item:{
            "Email":email,
            "FirstName":firstName,
            "LastName":lastName,
            "Password":hashedpassword,
            "RoleId":"2",
            "AccountHold":true,
            "DateSubmitted":timestamp,
            "GMTInfo":offset,
            "IsDeleted":false,
            "IsEnabled":true,
            "SubscriptionId":1,
            "UserId":uniqueId
          }
        }
      }else{
        params={
          TableName:"Users",
          Item:{
            "Email":email,
            "FirstName":firstName,
            "LastName":lastName,
            "Password":hashedpassword,
            "RoleId":"2",
            "AccountHold":true,
            "DateSubmitted":timestamp,
            "GMTInfo":offset,
            "IsDeleted":false,
            "IsEnabled":true,
            "SubscriptionId":1
          }
        }
      }
       
   
      dynamoDBClient.put(params,(err,data)=>{
        if(err){
          setErr("* Unable to save record")
          console.log("Error writing ",err)
        }else{
          navigate(ROUTE.Home)
          console.log("successfully write in table")
        }
      })
      
    }).catch((err)=>{
      console.log("validation failed",err.errors)
      Errors(err.errors)
    })
    
  }

  return (
    <RegisterStyle>
      <div className='body'>
        <i className="bi bi-arrow-left-circle-fill back-icon" onClick={()=>navigate(ROUTE.Home)}>Back Home</i>
        <div className='container2'>
          <div className="register-container">
            <img src='logo.png' className='app-logo' alt="logo" />
            <h1 className='description'>BE IN THE KNOW</h1>
            <form onSubmit={handleSubmit} className="form-container" >
              <label className='form-text'>First Name</label>
              <br />
              <input type="text" placeholder='Enter First Name' className='form-control mt-1 input-field' value={firstName} onChange={e =>{
                setFirstErr("");
                setFirstName(e.target.value)}} />
              <TextErrorStyle>{firstErr}</TextErrorStyle>
           
              <label className='form-text'>Last Name</label>
              <br />
              <input type="text" placeholder='Enter Last Name' className='form-control mt-1 input-field' value={lastName} onChange={e =>{
                setLastErr("")
                setLastName(e.target.value)}} />
                <TextErrorStyle>{lastErr}</TextErrorStyle>
           
              <label className='form-text'>Email</label>
              <br />
              <input type="text" placeholder='Enter Email' className='form-control mt-1 input-field' value={email} onChange={e =>{
                setEmailErr("")
                setEmail(e.target.value)}} />
                <TextErrorStyle>{emailErr}</TextErrorStyle>
          
            <label className='form-text' >Password</label>
            <br />
              <input type="password" placeholder='Enter Password' className='form-control mt-1 input-field' value={password} onChange={e =>{
                setEmailErr("");
                setPassword(e.target.value)}} />
            <TextErrorStyle>{passwordErr}</TextErrorStyle>
           
            <button type="submit" className='btn form-button' >Register</button>
            <p className='text-error2'>{err}</p>
          </form>

          </div>
        </div>
      </div>
    </RegisterStyle>
  )
}

export default Register